import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

export const LabelLinkWrapperExt = styled.a`
  text-decoration: none;
  display: flex;
  align-items: center;
  ${props => props.disableLink && css`
    pointer-events: none !important;
    cursor: default !important;
  `};
  ${props => props.color && css`
    color: ${props.color};
  `};
`;

export const LabelLinkWrapperInt = styled(Link)`
  text-decoration: none;
  display: flex;
  align-items: center;
  ${props => props.disableLink && css`
    pointer-events: none !important;
    cursor: default !important;
  `};
  ${props => props.color && css`
     color: ${props.color};
  `};
`;
